"use client"

import { useState } from "react"

import { useCovi } from "../contexts/CoviContext"
import { CoviThreadBar } from "./CoviThreadBar"

// The landing never mounts a thread body, so nothing is streaming from its
// vantage point — the per-row streaming glyph belongs to the full-page surface.
const NO_STREAMING: ReadonlySet<string> = new Set()

/**
 * The Sofia Home landing's chat switcher, shown as the "New chat" crumb in the
 * app-shell breadcrumb ("Sofia › New chat ⌄") whenever the chat rail is
 * collapsed. Clicking it opens the same popover the docked and full-page
 * surfaces use — a "New chat" action and the full chat history — so a landing
 * with the rail put away still reaches its history the way every other Sofia
 * view does.
 *
 * The landing shows the fresh-chat composer rather than a specific chat, so the
 * crumb always reads "New chat" (thread/active are null) and nothing in the
 * list is marked current. Picking a chat expands it onto the full-page Home
 * surface; starting a new chat returns to this landing, which is already the
 * blank-slate surface a new chat begins from.
 */
export function SofiaHomeThreadSwitcher() {
  const {
    threads,
    showThreadOnHome,
    startNewChatOnHome,
    renameThread,
    toggleThreadPinned,
    deleteThread,
  } = useCovi()
  const [open, setOpen] = useState(false)

  return (
    <CoviThreadBar
      thread={null}
      threads={threads}
      activeThreadId={null}
      streamingThreadIds={NO_STREAMING}
      threadCount={threads.length}
      backgroundStreaming={false}
      open={open}
      onOpenChange={setOpen}
      onSelect={showThreadOnHome}
      onNew={startNewChatOnHome}
      onRename={renameThread}
      onTogglePin={toggleThreadPinned}
      onDelete={deleteThread}
    />
  )
}
